export enum UserAssignationType {
  Site = 'site',
  Sector = 'sector',
}
